import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircleIcon, UserIcon } from 'lucide-react';
export function AboutSection() {
  const stats = [{
    value: 'Perth',
    label: 'BASED'
  }, {
    value: '1:1',
    label: 'PERSONALISED STRATEGY'
  }, {
    value: 'Invest',
    label: 'BUILT TO SCALE'
  }, {
    value: 'Facts',
    label: 'STRATEGY OVER HYPE'
  }];
  const points = ['You work directly with me', 'Every strategy is built around your situation, not a template.', 'I focus on long-term positioning, not just getting a loan approved.', 'Clear, honest communication — no jargon, no pressure.'];
  return <section id="about" className="py-24 bg-white dark:bg-[#0f1629] border-t border-slate-100 dark:border-white/5 transition-colors duration-300 relative z-10" data-id="element-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
        {/* Why Work With Me */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24" data-id="element-14">
          <div data-id="element-15">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-50 dark:bg-primary-500/10 border border-slate-200 dark:border-primary-500/20 shadow-sm dark:shadow-none mb-6" data-id="element-16">
              <span className="text-sm font-medium text-primary-600 dark:text-primary-400" data-id="element-17">
                Why Work With Me
              </span>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-slate-900 dark:text-white mb-6 leading-tight" data-id="element-18">
              Strategy isn't just something I talk about —{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-accent-500 to-primary-500" data-id="element-19">
                it's something I apply.
              </span>
            </h2>
            <p className="text-lg text-slate-600 dark:text-slate-400 mb-6 leading-relaxed" data-id="element-20">
              I didn't start this business just to write loans. I started it
              because I saw a massive gap — too many brokers are order-takers,
              focused on getting a single deal done rather than looking at the
              big picture.
            </p>
            <p className="text-lg text-slate-600 dark:text-slate-400 mb-8 leading-relaxed" data-id="element-21">
              As an active property investor myself, I understand the nuances of
              building a portfolio. The structure of your first loan dictates
              your ability to get your third or fourth. I know how to navigate
              lender policies to maximise your position when it matters most.
            </p>

            <ul className="space-y-4 mb-8" data-id="element-22">
              {points.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-23">
                  <CheckCircleIcon className="w-5 h-5 text-primary-500 flex-shrink-0 mt-0.5" data-id="element-24" />
                  <span className="text-slate-600 dark:text-slate-300 text-sm leading-relaxed" data-id="element-25">
                    {item}
                  </span>
                </li>)}
            </ul>

            
          </div>

          {/* Stats & Mission */}
          <div className="relative" data-id="element-26">
            <div className="absolute inset-0 bg-gradient-to-tr from-accent-500/8 to-primary-500/8 dark:from-accent-600/15 dark:to-primary-600/15 rounded-3xl blur-3xl -z-10" data-id="element-27"></div>
            <div className="bg-slate-50 dark:bg-[#1a2035] border border-slate-200 dark:border-white/10 rounded-3xl p-8 shadow-xl dark:shadow-none" data-id="element-28">
              <div className="grid grid-cols-2 gap-4" data-id="element-29">
                {stats.map((stat, index) => <div key={index} className="text-center p-4 md:p-6 rounded-2xl bg-white dark:bg-white/5 border border-slate-100 dark:border-white/5 flex flex-col items-center justify-center min-h-[120px] md:min-h-[140px] shadow-sm dark:shadow-none" data-id="element-30">
                    <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-accent-500 to-primary-500 mb-2" data-id="element-31">
                      {stat.value}
                    </div>
                    <div className="text-[10px] sm:text-xs font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wider leading-tight" data-id="element-32">
                      {stat.label}
                    </div>
                  </div>)}
              </div>

              <div className="mt-6 p-6 rounded-2xl bg-gradient-to-r from-accent-600 to-primary-600 text-white shadow-lg" data-id="element-33">
                <h3 className="text-lg font-semibold mb-2" data-id="element-34">Our Mission</h3>
                <p className="text-primary-50 text-sm leading-relaxed" data-id="element-35">
                  To help Australians build real wealth through property — by
                  simplifying strategy, structuring loans properly, and giving
                  them the confidence to scale.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}